import React, { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal } from 'reducers/Modal';

import { MODALS_BY_NAME } from './list';

export default function ModalManagerNoRoute() {
	const dispatch = useDispatch();
	const { name, isOpen, props } = useSelector((state) => state.get('modal'));

	// This manager mounts solely inside the Dashboard, so a modal already flagged
	// open at first mount is stale state left by a pre-Dashboard screen. The
	// opener (UserDropDown via CommonHeader) does render on pre-Dashboard
	// intake/registration screens — that's the bug — but no manager mounts there
	// to render or dismiss the modal, so the slice can reach us already open.
	// Clear it so it can't pop unprompted. Empty deps make this mount-only: later,
	// user-initiated opens are legitimate and rendered below. useLayoutEffect (not
	// useEffect) clears before paint, so it never flashes.
	useLayoutEffect(() => {
		if (isOpen) dispatch(closeModal());
	}, []);

	const Component = MODALS_BY_NAME[name];

	if (!Component || !isOpen) return null;

	return (
		<>
			<Component {...props} />
		</>
	);
}
